import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AcademicPlanTemplateService from "../../src/Services/AcademicPlanTemplate.service";
const AcademicPlanTemplateLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<AcademicPlanTemplate[]>' is not assignable to type '(ids: string[]) => Promise<AcademicPlanTemplate[]>'.
        fetchItemsById: (ids) => {
            return AcademicPlanTemplateService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AcademicPlanTemplateService.searchAll(search);
        },
        optionRenderer: function optionRenderer(academicPlanTemplate) {
            return _jsx("span", { children: academicPlanTemplate.name });
        },
    });
};
export default AcademicPlanTemplateLookup;
